import { createClient } from 'contentful'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  const client = createClient({
    space: runtimeConfig.public.ctfId,
    host: runtimeConfig.public.ctfHost,
    environment: runtimeConfig.public.ctfEnv,
    accessToken: runtimeConfig.public.ctfAccessToken,
  })

  return {
    provide: {
      client,
    },
  }
})
